import React, {Component} from 'react';
import classNames from 'classnames';
import Style from './FJExportSuccess.module.less';
import exportSuccess from '../../../icon/export-success.svg';
import InlineSVG from "react-inlinesvg";
import exportEdit from '../../../icon/export-edit.svg';
import exportDropBox from '../../../icon/export-dropbox.svg';
import exportYoutube from '../../../icon/export-youtube.svg';
import FJClose from "./FJClose.icon";

class FJExportSuccess extends Component {

    _renderItem = (props) => {
        const {isShow, type, onClick, icon, text, className} = props;
        return (
            <div className={classNames(Style.item_box, className)}
                 key={type}
                 onClick={onClick}
                 style={{display: isShow ? 'flex' : 'none'}}>
                {icon}
                <div className={Style.text}>
                    {text}
                </div>
            </div>
        );
    };

    /**
     * @description
     * @private
     */
    _renderYoutube = () => {
        let {isSharing, sharingProgress, couldUseYoutube, youtubeText, uploadSuccessText} = this.props;
        let {onShareToYoutube} = this.props;
        let shownProgress = Math.round(sharingProgress * 100);
        if (couldUseYoutube) {
            return <div className={classNames(Style.item_box, Style.youtobe)}>
                {
                    !isSharing && shownProgress === 0 ? <div className={Style.btn} onClick={onShareToYoutube}>
                        <InlineSVG src={exportYoutube} element='div'/>
                        <div className={Style.text}>{youtubeText}</div>
                    </div> : null
                }
                {
                    isSharing ? <div className={Style.progress_box}>
                        <div className={Style.progress}>
                            <div className={Style.progress_inner} style={{width: shownProgress + '%'}}/>
                        </div>
                        <div className={Style.text}>{shownProgress + '%'}</div>
                    </div> : null
                }
                {
                    !isSharing && shownProgress === 100 ? <div className={Style.upload_success}>
                        {uploadSuccessText}
                    </div> : null
                }
            </div>
        } else {
            return null;
        }
    };

    render() {

        const {title, isShow, downloadTitle, downloadBtnText, continueText, dropBoxText, couldUseDropbox} = this.props;
        const {onDownload, onClose, onContinue, onUploadToDropBox} = this.props;

        const continueData = {
            icon: <InlineSVG src={exportEdit} element='div'/>,
            className: Style.edit,
            onClick: onContinue,
            text: continueText,
            isShow: true,
            type: 'continue',
        };
        const dropBoxData = {
            icon: <InlineSVG src={exportDropBox} element='div'/>,
            className: Style.drop,
            onClick: onUploadToDropBox,
            text: dropBoxText,
            isShow: couldUseDropbox,
            type: 'dropBox',
        };

        return (
            <div className={Style.box} style={{display: isShow ? 'flex' : 'none'}}>
                <div className={Style.close} onClick={onClose}>
                    <FJClose/>
                </div>
                <div className={Style.content}>
                    <div className={Style.success_icon}>
                        <InlineSVG src={exportSuccess} element='div'/>
                    </div>
                    <div className={Style.title}>{title}</div>
                    <div className={Style.download}>
                        <div className={Style.download_title}>{downloadTitle} </div>
                        <div className={Style.download_btn} onClick={onDownload}> {downloadBtnText}</div>
                    </div>
                    <div className={Style.success_buttons}>
                        {this._renderItem(continueData)}
                        {this._renderItem(dropBoxData)}
                        {this._renderYoutube()}
                    </div>
                </div>
            </div>
        );
    }
}


export default FJExportSuccess
